import axios from '../utils/axios';

export default function fetchRefreshJobHistory(adminId, params) {
    return (
        axios.get(`/admin/${adminId}/job-refresh-history`, { params })
            .then(res => {
                return res.data
            })
            .catch(err => {
                return err;
            })
    )
}